import { render, staticRenderFns } from "./DataValue.vue?vue&type=template&id=44f01033&scoped=true&"
import script from "./DataValue.vue?vue&type=script&lang=js&"
export * from "./DataValue.vue?vue&type=script&lang=js&"
import style0 from "./DataValue.vue?vue&type=style&index=0&id=44f01033&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f01033",
  null
  
)

export default component.exports